import { TextField, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { WHITE } from "../style/theme";
import { useRestCall } from "./rest";


export function UEditableTextField(props) {
    const [edit, setEdit] = useState(false)
    const { value, defValue, restCommit, onChange, onComplete, multiline, textFieldProps, ...rest } = props;
    const textRef = useRef();
    const [call, loading] = useRestCall(
        () => {
            onComplete && onComplete();
            setEdit(false);
        }, () => setEdit(false))

    function commitEdit() {
        const editValue = textRef.current.value;
        if (editValue && editValue !== value) {
            onChange && onChange(editValue)
            if (restCommit) {
                call(restCommit, editValue)
            } else {
                setEdit(false)
            }
        } else {
            setEdit(false)
        }
    }

    useEffect(() => {
        if (edit) {
            textRef.current.value = value ? value : ''
            textRef.current.focus()
        }
    }, [edit])

    if (edit) {

        if (multiline) {
            return <TextField
                multiline
                inputProps={{
                    sx: {
                        paddingTop: 0,
                        minHeight: 100,
                    }
                }}
                sx={{
                    fontSize: 1,
                    "*": {
                        padding: 1 + ' !important',
                        paddingTop: 1,
                    },
                }}
                disabled={loading}
                size="small"
                inputRef={textRef}
                onBlur={commitEdit}
                variant="filled"
                {...textFieldProps}
            ></TextField>
        }

        return <TextField
            inputProps={{
                sx: {
                    padding: 0,
                }
            }}
            sx={{
                fontSize: 1,
            }}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    commitEdit()
                }
            }}
            disabled={loading}
            size="small"
            inputRef={textRef}
            onBlur={commitEdit}
            variant="filled"
            {...textFieldProps}
        ></TextField>
    }

    return <Typography onClick={() => setEdit(true)} {...rest} >
        {Boolean(value) || value === 0 ? value : defValue}
    </Typography>
}